import { map } from 'lodash';
import type { FC } from 'react';
import React, { useContext } from 'react';

import ProductItem from '../../../components/ProductItem';
import ConfigRentContext from '../../../service/context/config-rent';
import useAppStoreRent from '../../../service/store/appRent';
import useOrderStoreRent from '../../../service/store/orderRent';
import type { IRentalProduct } from '../../../types';

import './../../../components/ProductList.scss';

const ProductList: FC = () => {
  const appContext = useContext(ConfigRentContext);
  const { disabled_products } = appContext || {};
  const addProduct = useOrderStoreRent(state => state.addProduct);
  const products = useOrderStoreRent(state => state.order.products);
  const {
    filteredProducts
  } = useAppStoreRent(state => state);

  const handleProductCardClick = (productItem: IRentalProduct): void => {
    addProduct(productItem);
  };

  return (
    <div className="manufacturer-group-container">
      {filteredProducts && (
        <div className="product-list product-list-rent">
          {map(filteredProducts, productItem => {
            const quantity = products[productItem.id]?.quantity ?? 0;

            return (
              <ProductItem
                type="rent"
                key={productItem.id}
                name={productItem.name}
                image={productItem.image}
                btnText="Gerät mieten"
                disabled={disabled_products?.includes(productItem.name)}
                badgeText={quantity > 0 ? `${quantity}x` : undefined}
                onClick={() => handleProductCardClick(productItem)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductList;
